import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import NewBook from "@/pages/NewBook";
import Editor from "@/pages/Editor";
import Preview from "@/pages/Preview";
import Checkout from "@/pages/Checkout";
import OrderPage from "@/pages/OrderPage";
import Privacy from "@/pages/Privacy";
import Policy from "@/pages/Policy";
import SharedBook from "@/pages/SharedBook";
import CaricatureNew from "@/pages/CaricatureNew";
import CaricatureView from "@/pages/CaricatureView";
import GiftPage from "@/pages/GiftPage";
import Pricing from "@/pages/Pricing";
import AdminPromos from "@/pages/AdminPromos";
import AdminOrders from "@/pages/AdminOrders";
import AdminPrint from "@/pages/AdminPrint";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-[#8C8498] font-serif text-2xl">Opening your albums…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}&expired=1`} replace />;
  return children;
}

const P = (el) => <Protected>{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Policy kind="terms" />} />
          <Route path="/refunds" element={<Policy kind="refunds" />} />
          <Route path="/shipping" element={<Policy kind="shipping" />} />
          <Route path="/contact" element={<Policy kind="contact" />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/admin/promos" element={P(<AdminPromos />)} />
          <Route path="/admin/orders" element={P(<AdminOrders />)} />
          <Route path="/admin/print" element={P(<AdminPrint />)} />
          <Route path="/s/:token" element={<SharedBook />} />
          <Route path="/g/:token" element={<GiftPage />} />
          <Route path="/dashboard" element={P(<Dashboard />)} />
          <Route path="/new" element={P(<NewBook />)} />
          <Route path="/new/:bookId" element={P(<NewBook />)} />
          <Route path="/books/:bookId/edit" element={P(<Editor />)} />
          <Route path="/books/:bookId/preview" element={P(<Preview />)} />
          <Route path="/books/:bookId/checkout" element={P(<Checkout />)} />
          <Route path="/orders/:orderId" element={P(<OrderPage />)} />
          <Route path="/caricature" element={P(<CaricatureNew />)} />
          <Route path="/caricature/:id" element={P(<CaricatureView />)} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
